// all common component json mocks goes in this file..
import choithramsMail from '../../assets/images/common-assets/choithramsMail/choithramsMail.png';
import choithramsPhone from '../../assets/images/common-assets/choithramsPhone/choithramsPhone.png';
import choithramsFacebook from '../../assets/images/common-assets/choithramsFacebook/choithramsFacebook.png';
import choithramsRssFeed from '../../assets/images/common-assets/choithramsRssFeed/choithramsRssFeed.png';
import choithramsTwitter from '../../assets/images/common-assets/choithramsTwitter/choithramsTwitter.png';
import choithramsYoutube from '../../assets/images/common-assets/choithramsYoutube/choithramsYoutube.png';
import choithramsApple from '../../assets/images/common-assets/choithramsApple/choithramsApple.png';
import choithramsGoogle from '../../assets/images/common-assets/choithramsGoogle/choithramsGoogle.png';

import choithramsPepsi from '../../assets/images/common-assets/choithramsPepsi/choithramsPepsi.png';
import choithramsLays from '../../assets/images/common-assets/choithramsLays/choithramsLays.png';
import choithramsSimplyOrganic from '../../assets/images/common-assets/choithramsSimplyOrganic/choithramsSimplyOrganic.png';

import choithramsArrowRightB from '../../assets/images/common-assets/choithramsArrowRight/choithramsArrowRightB.png';
import choithramsArrowRightG from '../../assets/images/common-assets/choithramsArrowRight/choithramsArrowRightG.png';

import choithramsOrdersB from '../../assets/images/user-assets/choithramsOrders/choithramsOrdersB.png';
import choithramsOrdersG from '../../assets/images/user-assets/choithramsOrders/choithramsOrdersG.png';
import choithramsWalletB from '../../assets/images/user-assets/choithramsWallet/choithramsWalletB.png';
import choithramsWalletG from '../../assets/images/user-assets/choithramsWallet/choithramsWalletG.png';
import choithramsPasswordB from '../../assets/images/user-assets/choithramsPassword/choithramsPasswordB.png';
import choithramsPasswordG from '../../assets/images/user-assets/choithramsPassword/choithramsPasswordG.png';
import choithramsAccountB from '../../assets/images/user-assets/choithramsAccount/choithramsAccountB.png';
import choithramsAccountG from '../../assets/images/user-assets/choithramsAccount/choithramsAccountG.png';
import choithramsOffersB from '../../assets/images/user-assets/choithramsOffers/choithramsOffersB.png';
import choithramsOffersG from '../../assets/images/user-assets/choithramsOffers/choithramsOffersG.png';
import choithramsSubscriptionB from '../../assets/images/user-assets/choithramsSubscription/choithramsSubscriptionB.png';
import choithramsSubsctiptionG from '../../assets/images/user-assets/choithramsSubscription/choithramsSubscriptionG.png';
import choithramsHelpB from '../../assets/images/user-assets/choithramsHelp/choithramsHelpB.png';
import choithramsHelpG from '../../assets/images/user-assets/choithramsHelp/choithramsHelpG.png';
import choithramsLogoutB from '../../assets/images/user-assets/choithramsLogout/choithramsLogoutB.png';
import choithramsLogoutG from '../../assets/images/user-assets/choithramsLogout/choithramsLogoutG.png';

export const footerProducts = {
    title: 'PRODUCTS',
    links: [
        {
            id: 1,
            link: 'Fruits & Vegetables'
        },{
            id: 2,
            link: 'Groceries & Staples'
        },{
            id: 3,
            link: 'Organic'
        },{
            id: 4,
            link: 'Bakery & Eggs & Dairy'
        },{
            id: 5,
            link: 'Coffee & Tea & Beverages'
        },{
            id: 6,
            link: 'Packaged Food'
        },{
            id: 7,
            link: 'Imported & Gourmet'
        },{
            id: 8,
            link: 'Fish & Meat'
        },{
            id: 9,
            link: 'Baby Care'
        },{
            id: 10,
            link: 'Personal Care'
        },{
            id: 11,
            link: 'Bathroom & Cleaning'
        }
    ]
};

export const footerKnowUs = {
    title: 'KNOW US',
    links: [
        {
            id: 1,
            link: 'About US'
        },{
            id: 2,
            link: 'FAQs'
        },{
            id: 3,
            link: 'News & Events'
        },{
            id: 4,
            link: 'Partner with Us'
        },{
            id: 5,
            link: 'Privacy Policy'
        },{
            id: 6,
            link: 'Terms & Conditions'
        },{
            id: 7,
            link: 'Join Us'
        },{
            id: 8,
            link: 'Return Policy'
        }
    ]
};

export const footerMyAccount = {
    title: 'MY ACCOUNT',
    links: [
        {
            id: 1,
            link: 'My Profile'
        },{
            id: 2,
            link: 'Orders'
        },{
            id: 3,
            link: 'My Lists'
        },{
            id: 4,
            link: 'My Favourite Stores'
        }
    ]
};

export const footerLinks = [
    {
        id: 1,
        title: 'PRODUCTS',
        links: [
            {
                id: 1,
                link: 'Fruits & Vegetables'
            },{
                id: 2,
                link: 'Groceries & Staples'
            },{
                id: 3,
                link: 'Organic'
            },{
                id: 4,
                link: 'Bakery & Eggs & Dairy'
            },{
                id: 5,
                link: 'Coffee & Tea & Beverages'
            },{
                id: 6,
                link: 'Packaged Food'
            },{
                id: 7,
                link: 'Imported & Gourmet'
            },{
                id: 8,
                link: 'Fish & Meat'
            },{
                id: 9,
                link: 'Baby Care'
            },{
                id: 10,
                link: 'Personal Care'
            },{
                id: 11,
                link: 'Bathroom & Cleaning'
            }
        ]
    },
    {
        id: 2,
        title: 'KNOW US',
        links: [
            {
                id: 1,
                link: 'About US',
                pathName: '/about'
            },{
                id: 2,
                link: 'FAQs'
            },{
                id: 3,
                link: 'News & Events'
            },{
                id: 4,
                link: 'Partner with Us'
            },{
                id: 5,
                link: 'Privacy Policy'
            },{
                id: 6,
                link: 'Terms & Conditions'
            },{
                id: 7,
                link: 'Join Us'
            },{
                id: 8,
                link: 'Return Policy'
            }
        ]
    },
    {
        id: 3,
        title: 'MY ACCOUNT',
        links: [
            {
                id: 1,
                link: 'My Profile',
                pathName: '/account'
            },{
                id: 2,
                link: 'Orders',
                pathName: '/my-orders'
            },{
                id: 3,
                link: 'My Lists',
                pathName: '/product-list'
            },{
                id: 4,
                link: 'My Favourite Stores',
                pathName: '/find-store'
            }
        ]
    }
];

export const footerContactUs = {
    title: "CONTACT",
    email: {
        image: choithramsMail,
        label: 'Email:',
        value: 'admin@choithrams1.com'
    },
    contact: {
        image: choithramsPhone,
        label: 'Call Us:',
        value: '+971 4 3411193',
        timings: '9am to 9pm everyday'
    },
    socialIcons: [
        {
            image: choithramsFacebook
        },
        {
            image: choithramsRssFeed
        },
        {
            image: choithramsTwitter
        },
        {
            image: choithramsYoutube
        }
    ],
    downloadApp: {
        title: 'GET THE APPLICATION',
        images: [
            {
                image: choithramsApple
            },
            {
                image: choithramsGoogle
            }
        ],
        choose: 'OR',
        input: {
            placeholderText: "Enter Your Mobile Number",
            buttonText: "SEND LINK"
        }
    }
};

export const navigationItems = [
    {
        id: 1,
        title: 'Daily Fresh',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [
            choithramsPepsi,
            choithramsLays,
            choithramsSimplyOrganic
        ],
        subNavigationItems: [
           {
                id: 1,
                title: 'FRUITS & VEGETABLES',
                subTitles: [
                    {
                        title: "Fruits"
                    },{
                        title: "Herbs"
                    },{
                        title: "Packed Lettuce & Mixed Leaf"
                    },{
                        title: "Vegetables"
                    }
                ]
           },
           {
                id: 2,
                title: "CHILLED FOOD COUNTER",
                subTitles: [
                    {
                        title: "Cold Cuts & Meat Snacks"
                    },{
                        title: "Dips,Spreads & Pate"
                    },{
                        title: "Olives & Anitpasti"
                    },{
                        title: "Seafood & Clover"
                    },{
                        title: "Tofu"
                    }
                ]
           },
           {
                id: 3,
                title: "DAIRY & EGGS",
                subTitles: [
                    {
                        title: "Butter & Margarine"
                    },{
                        title: "Cheese & Labneh"
                    },{
                        title: "Chilled Deserts"
                    },{
                        title: "Cream"
                    },{
                        title: "Eggs"
                    },{
                        title: "Milk & Laban"
                    },{
                        title: "Yoghurt"
                    }
               ]
           },
           {
                id: 4,
                title: "FISH & SEAFOOD",
                subTitles: [
                    {
                        title: "Fish"
                    },{
                        title: "Seafood"
                    }
                ]
           },
           {
                id: 5,
                title: "FOOD TO GO",
                subTitles: [
                    {
                        title: "Appetizers & Bites"
                    },{
                        title: "Ready Meals To Go"
                    },{
                        title: "Salads & Soup"
                    },{
                        title: "Sushi & Sashmi"
                    }
                ]
           },
           {
                id: 6,
                title: "MEAT & POULTRY",
                subTitles: [
                    {
                        title: "Beef"
                    },
                    {
                        title: "Chicken"
                    },
                    {
                        title: "Lamb"
                    },
                    {
                        title: "Offals"
                    },
                    {
                        title: "Veal"
                    },
                    {
                        title: "Variety Meat"
                    }
                ]
           },
           {
                id: 7,
                title: "READY TO COOK",
                subTitles: [
                    {
                        title: "Puff Pastry, Dough & Pizza Bases"
                    },{
                        title: "Pasta, Gnocchi & Sauces"
                    }
                ]
           },
           {
                id: 8,
                title: "RICE, PASTA & PULSES FOOD",
                subTitles: [
                    {
                        title: "Pulses, Grains & Couscous"
                    },{
                        title: "Pasta Food"
                    },{
                        title: "Rice Food"
                    }
                ]
           },
           {
                id: 9,
                title: "TINS, JARS & PACKETS",
                subTitles: [
                    {
                        title: "Canned Fruits"
                    },{
                        title: "Canned Meat"
                    },{
                        title: "Canned Vegetables"
                    },{
                        title: "Coconut Milk & Cream"
                    },{
                        title: "Pickles & Olives"
                    },{
                        title: "Powdered Milk"
                    },{
                        title: "Soup & Instant Noodles"
                    },{
                        title: "Tuna & Seafood"
                    }
                ]
           }
        ]
    },{
        id: 2,
        title: 'Cooking & Ingredients',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 3,
        title: 'Beverages',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 4,
        title: 'Pets Food',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 5,
        title: 'European Food',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 6,
        title: 'Home Life',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 7,
        title: 'Breakfast & Snacking',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 8,
        title: 'Frozen',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 9,
        title: 'Household',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 10,
        title: 'Ready To Cook',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    },{
        id: 11,
        title: 'Vegan Food',
        icons: {
            black: choithramsArrowRightB,
            grey: choithramsArrowRightG
        },
        images: [],
        subNavigationItems: []
    }
];

export const sidebarItems = [
    {
        id: 1,
        title: "My Orders",
        image: {
            black: choithramsOrdersB,
            green: choithramsOrdersG
        },
        pathName: '/my-orders'
    },{
        id: 2,
        title: "Choithrams Wallet",
        image: {
            black: choithramsWalletB,
            green: choithramsWalletG,
        },
        pathName : '/wallet'
    },{
        id: 3,
        title: "Change Password",
        image: {
            black: choithramsPasswordB,
            green: choithramsPasswordG
        },
        pathName : '/change-password'
    },{
        id: 4,
        title: "Account",
        image: {
            black: choithramsAccountB,
            green: choithramsAccountG
        },
        pathName : '/account'
    },{
        id: 5,
        title: "Offers",
        image: {
            black: choithramsOffersB,
            green: choithramsOffersG
        },
        pathName : '/offers'
    },{
        id: 6,
        title: "Subscription",
        image: {
            black: choithramsSubscriptionB,
            green: choithramsSubsctiptionG
        },
        pathName : '/subscription'
    },{
        id: 7,
        title: "Help",
        image: {
            black: choithramsHelpB,
            green: choithramsHelpG
        },
        pathName : '/help'
    },{
        id: 8,
        title: "Logout",
        image: {
            black: choithramsLogoutB,
            green: choithramsLogoutG
        },
        pathName: '/logout'
    }
];
